import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"

import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import Select from "react-select"
import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"
import { Multiselect } from "multiselect-react-dropdown"
import ExpertExtraEmployee from "./ExpertExtraEmployee"

import ReactExport from "react-data-export"
import AddIcon from "@material-ui/icons/Add"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
            marginTop: "15px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
            padding: " 10px",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",
      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },
}

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
})

class ChangeExpert extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.multiselectCompanyRef = React.createRef()
            this.multiselectStateRef = React.createRef()
            this.multiselectCityRef = React.createRef()

            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  expertInfofilter: [],
                  expertExtraEmployee: [],
                  rowsPerPage: 5,
                  page: 0,
                  expert_id: "",
                  expert_code: "",
                  expert_name: "",
                  expert_family: "",
                  expert_mobile: "",
                  expert_tell: "",
                  expert_required_phone: "",
                  expert_email: "",
                  expert_address: "",
                  expert_bankname: "",
                  expert_banknum: "",
                  expert_banksheba: "",
                  expert_sector_name: "",
                  expert_evaluatorco_name: "",
                  expert_city_name: "",
                  expert_deactive: "1",
                  expert_status: "1",
                  expert_image: "",
                  expert_evaluatorco_logo_url: "",
                  orderBy: "expert_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newExpert: true,
                  picturesRequestReady: "",
                  selectedExpertExtraEmployee: "",

                  optionGender: [
                        { value: "آقا", label: "آقا" },
                        { value: "خانم", label: "خانم" },
                  ],
                  selectedGender: "",

                  optionComoany: [],
                  optionFilterComoany: "",
                  selectedComoany: "",

                  optionState: [],
                  selectedState: "",
                  optionCity: [],
                  optionFilterCity: [],
                  selectedCity: "",

                  loading: false,
                  percent: 0,
                  selectedFilterCompany: [],
                  selectedFilterState: [],
                  selectedFilterCity: [],
                  selectedFilterDeactive: "",
                  selectedFilterStatus: "",
                  idFilter: "",
                  codeFilter: "",
                  nameFilter: "",
                  familyFilter: "",
                  mobileFilter: "",
                  showPaperChart: false,
                  showMap: false,
                  showEnterExpert: false,
            }
      }

      handleBodycarExtracar = (selectedExpertExtraEmployee) => {
            this.setState({ selectedExpertExtraEmployee: selectedExpertExtraEmployee })
      }
      handleShowPaperChart = (event) => {
            this.setState({ showPaperChart: true })
      }

      handleHidePaperChart = (event) => {
            this.setState({ showPaperChart: false })
      }

      handleShowMap = (event) => {
            this.setState({ showMap: true })
      }

      handleHideMap = (event) => {
            this.setState({ showMap: false })
      }

      onSelectPicRequest = (picture) => {
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }

      handleChangeName = (event) => {
            this.setState({ expert_name: event.target.value })
      }
      handleChangCode = (event) => {
            this.setState({ expert_code: event.target.value })
      }
      handleChangeFamily = (event) => {
            this.setState({ expert_family: event.target.value })
      }

      handleChangeMobile = (event) => {
            this.setState({ expert_mobile: event.target.value })
      }

      handleChangeTell = (event) => {
            this.setState({ expert_tell: event.target.value })
      }
      handleChangeTellRequir = (event) => {
            this.setState({ expert_required_phone: event.target.value })
      }
      handleChangeEmail = (event) => {
            this.setState({ expert_email: event.target.value })
      }
      handleChangeAddress = (event) => {
            this.setState({ expert_address: event.target.value })
      }
      handleChangeBankName = (event) => {
            this.setState({ expert_bankname: event.target.value })
      }
      handleChangeBankNum = (event) => {
            this.setState({ expert_banknum: event.target.value })
      }
      handleChangeBankSheba = (event) => {
            this.setState({ expert_banksheba: event.target.value })
      }
      handleChangeSector = (event) => {
            this.setState({ expert_sector_name: event.target.value })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ expert_deactive: "0" })
            } else {
                  this.setState({ expert_deactive: "1" })
            }
      }

      handleChangeStatus = (event) => {
            if (event.target.checked) {
                  this.setState({ expert_status: "1" })
            } else {
                  this.setState({ expert_status: "0" })
            }
      }

      handleSelectRows = (row2) => {
            this.getExpertExtraEmployee(row2.expert_id)
            this.setState(
                  {
                        expert_code: row2.expert_code,
                        expert_id: row2.expert_id,
                        expert_name: row2.expert_name,
                        expert_family: row2.expert_family,
                        expert_mobile: row2.expert_mobile,
                        expert_tell: row2.expert_tell,
                        expert_required_phone: row2.expert_required_phone,
                        expert_email: row2.expert_email,
                        expert_address: row2.expert_address,
                        expert_bankname: row2.expert_bankname,
                        expert_banknum: row2.expert_banknum,
                        expert_banksheba: row2.expert_banksheba,
                        expert_sector_name: row2.expert_sector_name,
                        expert_deactive: row2.expert_deactive,
                        expert_status: row2.expert_status,
                        expert_image: row2.expert_image,
                        expert_evaluatorco_logo_url: row2.expert_evaluatorco_logo_url,
                        newExpert: false,
                        selectedGender: { value: row2.expert_gender, label: row2.expert_gender },
                        selectedComoany: { value: row2.expert_evaluatorco_id, label: row2.expert_evaluatorco_name, logo: row2.expert_evaluatorco_logo_url },
                        selectedState: { value: row2.expert_state_id, label: row2.expert_state_name },
                        selectedCity: { value: row2.expert_city_id, label: row2.expert_city_name },
                        showEnterExpert: true,
                  },
                  () => {
                        this.getoptionCityID()
                  }
            )
      }

      getExpertExtraEmployee(expert_id) {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            this.setState({ expertExtraEmployee: [] }, () => {
                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ expertExtraEmployee: arr.data }, () => {})
                              } else if (arr.result === "error") {
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "get_expert_extraemployee")
                  fd.append("expert_id", expert_id)

                  xhttp.open("POST", `${constants.BASE_URL}/expert`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            })
      }

      newExpertFunc = (event) => {
            this.setState({
                  expert_id: "",
                  expert_code: "",
                  expert_name: "",
                  expert_family: "",
                  expert_mobile: "",
                  expert_tell: "",
                  expert_required_phone: "",
                  expert_email: "",
                  expert_address: "",
                  expert_bankname: "",
                  expert_banknum: "",
                  expert_banksheba: "",
                  expert_sector_name: "",
                  expert_deactive: "0",
                  expert_status: "0",
                  expert_image: "",
                  expert_evaluatorco_logo_url: "",
                  newExpert: true,
                  selectedGender: {},
                  selectedComoany: {},
                  selectedState: {},
                  selectedCity: {},
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getExpert()
                                    self.getoptionStateID()
                                    self.getoptionCompany()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getExpert() {
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState(
                                    {
                                          requestinfos: arr.data,
                                          expertInfofilter: arr.data,
                                    },
                                    () => {}
                              )
                              self.getoptionBodycarExtracar()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        } else if (arr.result === "eror") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_expert")

            xhttp.open("POST", `${constants.BASE_URL}/expert`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionBodycarExtracar = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].employee_id,
                                          label: arr.data[k].employee_name + " " + arr.data[k].employee_family,
                                    })
                              }
                              self.setState({ optionBodycarExtracar: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee")
            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      getoptionCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Comoany = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Comoany.push({
                                          value: arr.data[k].evaluatorco_id,
                                          label: arr.data[k].evaluatorco_name,
                                          logo: arr.data[k].evaluatorco_logo_url,
                                    })
                              }
                              self.setState({ optionComoany: Comoany, selectedComoany: Comoany[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_evaluatorco")
            xhttp.open("POST", `${constants.BASE_URL}/evaluatorco`)
            xhttp.send(fd)
      }

      getoptionStateID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].state_id, label: arr.data[k].state_name })
                              }
                              self.setState({ optionState: State }, () => {
                                    //   self.getoptionCityID();
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_state")
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      getoptionCityID = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", this.state.selectedState.value)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      uploadPicDelivery = (mode) => {
            const {
                  expert_name,
                  expert_family,
                  expert_code,
                  expert_mobile,
                  expert_tell,
                  expert_required_phone,
                  expert_address,
                  expert_bankname,
                  expert_banknum,
                  expert_banksheba,
                  expert_sector_name,
                  selectedComoany,
                  selectedGender,
                  selectedState,
                  selectedCity,
                  expert_deactive,
                  expert_status,
            } = this.state
            const { picturesRequestReady } = this.state
            if (
                  expert_code != "" &&
                  expert_name != "" &&
                  expert_family != "" &&
                  expert_mobile != "" &&
                  expert_tell != "" &&
                  expert_address != "" &&
                  expert_bankname != "" &&
                  expert_banknum != "" &&
                  expert_banksheba != "" &&
                  selectedComoany != "" &&
                  selectedGender != "" &&
                  selectedState != "" &&
                  selectedCity != "" &&
                  expert_deactive != "" &&
                  expert_status != ""
            ) {
                  if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          if (mode === "new") {
                                                self.saveNewExpert(arr.data["image_code"])
                                          } else {
                                                self.changeExpert(arr.data["image_code"])
                                          }
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", picturesRequestReady)
                        fd.append("image_name", " تصویر کارشناس خسارت")
                        fd.append("image_desc", "تصویر کارشناس خسارت")
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        if (mode === "new") {
                              this.saveNewExpert("")
                        } else {
                              this.changeExpert("")
                        }
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات کارشناس خسارت را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      saveNewExpert = (imageCode) => {
            const {
                  expert_name,
                  expert_family,
                  expert_code,
                  expert_mobile,
                  expert_tell,
                  expert_required_phone,
                  expert_email,
                  expert_address,
                  expert_bankname,
                  expert_banknum,
                  expert_banksheba,
                  expert_sector_name,
                  selectedComoany,
                  selectedGender,
                  selectedState,
                  selectedCity,
                  expert_deactive,
                  expert_status,
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getExpert()
                              self.newExpertFunc()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_expert")
            fd.append("expert_name", expert_name)
            fd.append("expert_code", expert_code)
            fd.append("expert_family", expert_family)
            fd.append("expert_mobile", expert_mobile)
            fd.append("expert_tell", expert_tell)
            fd.append("expert_required_phone", expert_required_phone)
            fd.append("expert_email", expert_email)
            fd.append("expert_address", expert_address)
            fd.append("expert_bankname", expert_bankname)
            fd.append("expert_banknum", expert_banknum)
            fd.append("expert_banksheba", expert_banksheba)
            fd.append("expert_sector_name", expert_sector_name)
            fd.append("expert_evaluatorco_id", selectedComoany.value)
            fd.append("expert_gender", selectedGender.value)
            fd.append("expert_state_id", selectedState.value)
            fd.append("expert_city_id", selectedCity.value)
            fd.append("expert_deactive", expert_deactive)
            fd.append("expert_image_code", imageCode)
            fd.append("expert_status", expert_status)

            xhttp.open("POST", `${constants.BASE_URL}/expert`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeExpert = (imageCode) => {
            const {
                  expert_id,
                  expert_code,
                  expert_name,
                  expert_family,
                  expert_mobile,
                  expert_tell,
                  expert_required_phone,
                  expert_email,
                  expert_address,
                  expert_bankname,
                  expert_banknum,
                  expert_banksheba,
                  expert_sector_name,
                  selectedComoany,
                  selectedGender,
                  selectedState,
                  selectedCity,
                  expert_deactive,
                  expert_status,
            } = this.state
            this.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getExpert()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "modify_expert")
            fd.append("expert_id", expert_id)
            fd.append("expert_name", expert_name)
            fd.append("expert_code", expert_code)
            fd.append("expert_family", expert_family)
            fd.append("expert_mobile", expert_mobile)
            fd.append("expert_tell", expert_tell)
            fd.append("expert_required_phone", expert_required_phone)
            fd.append("expert_email", expert_email)
            fd.append("expert_address", expert_address)
            fd.append("expert_bankname", expert_bankname)
            fd.append("expert_banknum", expert_banknum)
            fd.append("expert_banksheba", expert_banksheba)
            fd.append("expert_sector_name", expert_sector_name)
            fd.append("expert_evaluatorco_id", selectedComoany.value)
            fd.append("expert_gender", selectedGender.value)
            fd.append("expert_state_id", selectedState.value)
            fd.append("expert_city_id", selectedCity.value)
            fd.append("expert_deactive", expert_deactive)
            if (imageCode !== "") {
                  fd.append("expert_image_code", imageCode)
            }
            fd.append("expert_status", expert_status)

            xhttp.open("POST", `${constants.BASE_URL}/expert`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.expertInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      handleState = (selectedState) => {
            this.setState({ selectedState: selectedState, selectedCity: null }, () => {
                  this.getoptionCityID()
            })
      }

      handleCity = (selectedCity) => {
            this.setState({ selectedCity: selectedCity })
      }

      handleCompany = (selectedComoany) => {
            this.setState({ selectedComoany: selectedComoany })
      }
      handleGender = (selectedGender) => {
            this.setState({ selectedGender: selectedGender })
      }

      onSelectOptionCompany = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterCompany: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionCompany = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterCompany: selectedList,
                  },
                  () => {}
            )
      }
      onSelectOptionCity = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterCity: selectedList,
                  },
                  () => {}
            )
      }

      onRemoveOptionCity = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterCity: selectedList,
                  },
                  () => {}
            )
      }
      onSelectOptionState = (selectedList, selectedItem) => {
            this.setState(
                  {
                        selectedFilterState: selectedList,
                  },
                  () => {
                        this.getOptionFilterCity()
                  }
            )
      }

      onRemoveOptionState = (selectedList, removedItem) => {
            this.setState(
                  {
                        selectedFilterState: selectedList,
                  },
                  () => {
                        this.getOptionFilterCity()
                  }
            )
      }
      getOptionFilterCity = () => {
            const { selectedFilterState, optionState } = this.state
            this.setState({ optionFilterCity: [] }, () => {
                  for (var i = 0; i < selectedFilterState.length; i++) {
                        this.getCity(selectedFilterState[i].value)
                  }
            })
      }

      getCity = (state_id) => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var State
                              if (self.state.optionFilterCity.length > 0) {
                                    var State = self.state.optionFilterCity
                              } else {
                                    var State = []
                              }
                              for (var k = 0; k < arr.data.length; k++) {
                                    State.push({ value: arr.data[k].city_id, label: arr.data[k].city_name })
                              }
                              self.setState({ optionFilterCity: State })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_city")
            fd.append("state_id", state_id)
            xhttp.open("POST", `${constants.BASE_URL}/statecity`)
            xhttp.send(fd)
      }

      handleFilterDeactive = (selectedFilterDeactive) => {
            this.setState({ selectedFilterDeactive: selectedFilterDeactive }, () => {})
      }
      handleFilterStatus = (selectedFilterStatus) => {
            this.setState({ selectedFilterStatus: selectedFilterStatus }, () => {})
      }
      handleChangeFilterId = (event) => {
            this.setState({ idFilter: event.target.value }, () => {})
      }

      handleChangeFilterCode = (event) => {
            this.setState({ codeFilter: event.target.value }, () => {})
      }

      handleChangeFilterName = (event) => {
            this.setState({ nameFilter: event.target.value }, () => {})
      }
      handleChangeFilterFamily = (event) => {
            this.setState({ familyFilter: event.target.value }, () => {})
      }
      handleChangeFilterMobile = (event) => {
            this.setState({ mobileFilter: event.target.value }, () => {})
      }
      filterFunc = () => {
            const {
                  requestinfos,
                  expertInfofilter,
                  selectedFilterState,
                  selectedFilterCity,
                  selectedFilterCompany,
                  idFilter,
                  codeFilter,
                  nameFilter,
                  familyFilter,
                  mobileFilter,
                  selectedFilterDeactive,
                  selectedFilterStatus,
            } = this.state
            var i, j, temparray2, temparray, b1, b2, b3
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < requestinfos.length; i++) {
                  if (temparray[i].expert_status !== "1") {
                        temparray[i].expert_status = "0"
                  }
                  if (
                        ((idFilter !== "" && temparray[i].expert_id.includes(idFilter)) || idFilter === "") &&
                        ((codeFilter !== "" && temparray[i].expert_code.includes(codeFilter)) || codeFilter === "") &&
                        ((nameFilter !== "" && temparray[i].expert_name.includes(nameFilter)) || nameFilter === "") &&
                        ((familyFilter !== "" && temparray[i].expert_family.includes(familyFilter)) || familyFilter === "") &&
                        ((mobileFilter !== "" && temparray[i].expert_mobile.includes(mobileFilter)) || mobileFilter === "") &&
                        ((selectedFilterDeactive !== "" && temparray[i].expert_deactive === selectedFilterDeactive.value) ||
                              selectedFilterDeactive === "" ||
                              selectedFilterDeactive.value === "10") &&
                        ((selectedFilterStatus !== "" && temparray[i].expert_status === selectedFilterStatus.value) ||
                              selectedFilterStatus === "" ||
                              selectedFilterStatus.value === "10")
                  ) {
                        b1 = false
                        b2 = false
                        b3 = false

                        if (selectedFilterState.length === 0) {
                              b1 = true
                        } else {
                              for (j = 0; j < selectedFilterState.length; j++) {
                                    if (temparray[i].expert_state_id === selectedFilterState[j].value) {
                                          b1 = true
                                    }
                              }
                        }
                        if (selectedFilterCity.length === 0) {
                              b2 = true
                        } else {
                              for (j = 0; j < selectedFilterCity.length; j++) {
                                    if (temparray[i].expert_city_id === selectedFilterCity[j].value) {
                                          b2 = true
                                    }
                              }
                        }
                        if (selectedFilterCompany.length === 0) {
                              b3 = true
                        } else {
                              for (j = 0; j < selectedFilterCompany.length; j++) {
                                    if (temparray[i].expert_evaluatorco_id === selectedFilterCompany[j].value) {
                                          b3 = true
                                    }
                              }
                        }
                        if (b1 && b2 && b3) {
                              temparray2.push(temparray[i])
                        }
                  }
            }
            this.setState({ expertInfofilter: temparray2 }, () => {})
      }

      saveNewPriceExpertExtraEmployee = () => {
            const { expert_id, selectedExpertExtraEmployee } = this.state
            if (selectedExpertExtraEmployee != "") {
                  this.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                                    self.setState({ selectedExpertExtraEmployee: "" })
                                    self.getExpertExtraEmployee(expert_id)
                              } else if (arr.result === "error") {
                                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "add_expert_extraemployee")
                  fd.append("expert_extra_expert_id", expert_id)
                  fd.append("expert_extra_employee_id", selectedExpertExtraEmployee.value)

                  xhttp.open("POST", `${constants.BASE_URL}/expert`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ snackstr: "لطفا مشخصات درصد پوشش مالی را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      ClearFilter = () => {
            this.setState({
                  selectedFilterCompany: [],
                  selectedFilterState: [],
                  selectedFilterCity: [],
                  selectedFilterDeactive: "",
                  selectedFilterStatus: "",
                  idFilter: "",
                  codeFilter: "",
                  nameFilter: "",
                  familyFilter: "",
                  mobileFilter: "",
                  optionFilterCity: [],
                  selectedOptionCity: [],
                  selectedOptionState: [],
                  expertInfofilter: this.state.requestinfos,
            })
            this.multiselectCompanyRef.current.resetSelectedValues()
            this.multiselectStateRef.current.resetSelectedValues()
            this.multiselectCityRef.current.resetSelectedValues()
      }
      HandelShowEnterExpert = () => {
            this.setState({
                  showEnterExpert: true,
            })
            this.newExpertFunc()
      }
      handleHideEnterExpert = () => {
            this.setState({
                  showEnterExpert: false,
            })
      }
      render() {
            const { classes } = this.props
            const {
                  selectedExpertExtraEmployee,
                  optionBodycarExtracar,
                  expertExtraEmployee,
                  showEnterExpert,
                  showPaperChart,
                  showMap,
                  mobileFilter,
                  familyFilter,
                  nameFilter,
                  codeFilter,
                  idFilter,
                  selectedFilterDeactive,
                  selectedFilterStatus,
                  loading,
                  percent,
                  optionCity,
                  optionFilterCity,
                  selectedCity,
                  selectedGender,
                  optionGender,
                  optionComoany,
                  selectedComoany,
                  optionState,
                  selectedState,
                  snackMode,
                  snackstr,
                  showSnack,
                  newExpert,
                  expert_id,
                  expert_code,
                  expert_name,
                  expert_family,
                  expert_image,
                  expert_evaluatorco_logo_url,
                  expert_mobile,
                  expert_tell,
                  expert_required_phone,
                  expert_email,
                  expert_address,
                  expert_bankname,
                  expert_banknum,
                  expert_banksheba,
                  expert_sector_name,
                  expert_deactive,
                  expert_status,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  expertInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      {showEnterExpert ? (
                                                            <Button variant="outlined" color="primary" onClick={this.handleHideEnterExpert}>
                                                                  {"مخفی کردن"}
                                                            </Button>
                                                      ) : (
                                                            <Button variant="outlined" color="primary" onClick={this.HandelShowEnterExpert}>
                                                                  {"کارشناس خسارت جدید"}
                                                            </Button>
                                                      )}
                                                      <Collapse in={showEnterExpert}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"آی دی کارشناس خسارت : " + expert_id}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <Avatar alt="Remy Sharp" className={classes.large} src={expert_image} />
                                                                  </Grid>

                                                                  <Grid item xs={12} sm={6}>
                                                                        <Grid container spacing={3}>
                                                                              <Grid item xs={3}>
                                                                                    <div>
                                                                                          <label className="on">جنسیت </label>
                                                                                          <Select
                                                                                                isSearchable={true}
                                                                                                className="adapter-txtsize"
                                                                                                placeholder={"جنسیت "}
                                                                                                value={selectedGender}
                                                                                                onChange={this.handleGender}
                                                                                                options={optionGender}
                                                                                          />
                                                                                    </div>
                                                                              </Grid>
                                                                              <Grid item xs={9}>
                                                                                    <FloatingLabelInput
                                                                                          placeholder="نام"
                                                                                          handleInputt={this.handleChangeName}
                                                                                          value={expert_name}
                                                                                    />
                                                                              </Grid>
                                                                        </Grid>
                                                                  </Grid>

                                                                  <Grid item xs={12} sm={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام خانوادگی"
                                                                              handleInputt={this.handleChangeFamily}
                                                                              value={expert_family}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شماره همراه "
                                                                              handleInputt={this.handleChangeMobile}
                                                                              value={expert_mobile}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شماره دفتر "
                                                                              handleInputt={this.handleChangeTell}
                                                                              value={expert_tell}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="ایمیل"
                                                                              handleInputt={this.handleChangeEmail}
                                                                              value={expert_email}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder=" تلفن ضروری "
                                                                              handleInputt={this.handleChangeTellRequir}
                                                                              value={expert_required_phone}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={5}>
                                                                        <div>
                                                                              <label className="on">شرکت ارزیاب خسارت</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"شرکت ارزیاب خسارت"}
                                                                                    value={selectedComoany}
                                                                                    onChange={this.handleCompany}
                                                                                    options={optionComoany}
                                                                              />
                                                                        </div>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <img
                                                                                    alt="Remy Sharp"
                                                                                    style={{ width: "25%" }}
                                                                                    src={selectedComoany.logo}
                                                                              />
                                                                        </div>
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                              placeholder="کد نمایندگی"
                                                                              handleInputt={this.handleChangCode}
                                                                              value={expert_code}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div>
                                                                              <label className="on">استان</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"استان"}
                                                                                    value={selectedState}
                                                                                    onChange={this.handleState}
                                                                                    options={optionState}
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div>
                                                                              <label className="on">شهر</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"شهر"}
                                                                                    value={selectedCity}
                                                                                    onChange={this.handleCity}
                                                                                    options={optionCity}
                                                                              />
                                                                        </div>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <FloatingLabelInput
                                                                              placeholder="آدرس"
                                                                              handleInputt={this.handleChangeAddress}
                                                                              value={expert_address}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام بانک"
                                                                              handleInputt={this.handleChangeBankName}
                                                                              value={expert_bankname}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شماره حساب"
                                                                              handleInputt={this.handleChangeBankNum}
                                                                              value={expert_banknum}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={4}>
                                                                        <FloatingLabelInput
                                                                              placeholder="شبا"
                                                                              handleInputt={this.handleChangeBankSheba}
                                                                              value={expert_banksheba}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام محله"
                                                                              handleInputt={this.handleChangeSector}
                                                                              value={expert_sector_name}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <ImageUploader
                                                                              withIcon={true}
                                                                              buttonText="عکس را انتخاب نمایید"
                                                                              onChange={this.onSelectPicRequest}
                                                                              withPreview="true"
                                                                              singleImage="true"
                                                                              imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                              maxFileSize={5242880}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <FormControlLabel
                                                                                    control={
                                                                                          <Switch
                                                                                                checked={expert_deactive === "0" ? true : false}
                                                                                                onChange={this.handleChangeDeactive}
                                                                                                name="gilad"
                                                                                          />
                                                                                    }
                                                                                    label="وضعیت فعالیت کارشناس خسارت"
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <FormControlLabel
                                                                                    control={
                                                                                          <Switch
                                                                                                checked={expert_status === "1" ? true : false}
                                                                                                onChange={this.handleChangeStatus}
                                                                                                name="gilad"
                                                                                          />
                                                                                    }
                                                                                    label="وضعیت آنلاین"
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        {loading && <LinearProgress variant="determinate" value={percent} />}
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        {newExpert ? (
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("new")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت کارشناس خسارت جدید "}
                                                                              </Button>
                                                                        ) : (
                                                                              <div style={{ width: "100%", textAlign: "right" }}>
                                                                                    <Button
                                                                                          variant="outlined"
                                                                                          color="primary"
                                                                                          onClick={this.newExpertFunc}
                                                                                    >
                                                                                          {"کارشناس خسارت جدید"}
                                                                                    </Button>
                                                                                    {"          "}
                                                                                    <Button
                                                                                          variant="outlined"
                                                                                          color="primary"
                                                                                          onClick={(e) => {
                                                                                                this.uploadPicDelivery("modify")
                                                                                          }}
                                                                                    >
                                                                                          {"ثبت تغییرات"}
                                                                                    </Button>
                                                                              </div>
                                                                        )}
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Paper
                                                                              style={{
                                                                                    backgroundColor: "#cfe8fc",
                                                                                    maxHeight: "300px",
                                                                                    overflowY: "scroll",
                                                                                    overflowX: "hidden",
                                                                              }}
                                                                              className={classes.root}
                                                                        >
                                                                              {newExpert ? null : (
                                                                                    <Grid container spacing={3}>
                                                                                          {expertExtraEmployee.map((expertExtraEmployee, index) => (
                                                                                                <ExpertExtraEmployee
                                                                                                      expertExtraEmployee={expertExtraEmployee}
                                                                                                      props={this.props}
                                                                                                      key={index}
                                                                                                />
                                                                                          ))}
                                                                                    </Grid>
                                                                              )}
                                                                        </Paper>
                                                                        {newExpert ? null : (
                                                                              <Grid item xs={12}>
                                                                                    <Grid container spacing={3}>
                                                                                          <Grid item xs={5}>
                                                                                                <div>
                                                                                                      <label className="on"> خودرو های اضافه </label>
                                                                                                      <Select
                                                                                                            isSearchable={true}
                                                                                                            className="adapter-txtsize"
                                                                                                            placeholder={"  کارمندان "}
                                                                                                            value={selectedExpertExtraEmployee}
                                                                                                            onChange={this.handleBodycarExtracar}
                                                                                                            options={optionBodycarExtracar}
                                                                                                      />
                                                                                                </div>
                                                                                          </Grid>

                                                                                          <Grid item item xs={3}>
                                                                                                <div style={{ width: "100%", textAlign: "left" }}>
                                                                                                      <Fab
                                                                                                            className={classes.small}
                                                                                                            color="primary"
                                                                                                            aria-label="add"
                                                                                                            onClick={
                                                                                                                  this.saveNewPriceExpertExtraEmployee
                                                                                                            }
                                                                                                      >
                                                                                                            <AddIcon />
                                                                                                      </Fab>
                                                                                                </div>
                                                                                          </Grid>
                                                                                    </Grid>
                                                                              </Grid>
                                                                        )}
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "left" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.handleHideEnterExpert}
                                                                              >
                                                                                    {"مخفی کردن"}
                                                                              </Button>
                                                                        </div>
                                                                  </Grid>
                                                            </Grid>
                                                      </Collapse>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      {showPaperChart ? (
                                                            <Button variant="outlined" color="primary" onClick={this.handleHidePaperChart}>
                                                                  {"مخفی کردن"}
                                                            </Button>
                                                      ) : (
                                                            <Button variant="outlined" color="primary" onClick={this.handleShowPaperChart}>
                                                                  {"جستجو"}
                                                            </Button>
                                                      )}

                                                      <Collapse in={showPaperChart}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                              placeholder="آی دی کارشناس خسارت"
                                                                              value={idFilter}
                                                                              handleInputt={this.handleChangeFilterId}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <FloatingLabelInput
                                                                              placeholder="کد کارشناس خسارت"
                                                                              value={codeFilter}
                                                                              handleInputt={this.handleChangeFilterCode}
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Multiselect
                                                                                    style={styleselect}
                                                                                    options={optionComoany} // Options to display in the dropdown
                                                                                    //selectedValues={selectedOptionCompany} // Preselected value to persist in dropdown
                                                                                    onSelect={this.onSelectOptionCompany} // Function will trigger on select event
                                                                                    onRemove={this.onRemoveOptionCompany} // Function will trigger on remove event
                                                                                    ref={this.multiselectCompanyRef}
                                                                                    displayValue="label" // Property name to display in the dropdown options
                                                                                    placeholder="شرکت ارزیاب خسارت"
                                                                                    closeIcon="circle2"
                                                                                    emptyRecordMsg="فیلد  در دسترس نیست "
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام "
                                                                              value={nameFilter}
                                                                              handleInputt={this.handleChangeFilterName}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="نام خانوادگی"
                                                                              value={familyFilter}
                                                                              handleInputt={this.handleChangeFilterFamily}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Multiselect
                                                                                    style={styleselect}
                                                                                    options={optionState} // Options to display in the dropdown
                                                                                    //selectedValues={selectedOptionState} // Preselected value to persist in dropdown
                                                                                    onSelect={this.onSelectOptionState} // Function will trigger on select event
                                                                                    onRemove={this.onRemoveOptionState} // Function will trigger on remove event
                                                                                    ref={this.multiselectStateRef}
                                                                                    displayValue="label" // Property name to display in the dropdown options
                                                                                    placeholder="استان ها "
                                                                                    closeIcon="circle2"
                                                                                    emptyRecordMsg="فیلد  در دسترس نیست "
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <div style={{ width: "100%", textAlign: "center" }}>
                                                                              <Multiselect
                                                                                    style={styleselect}
                                                                                    options={optionFilterCity} // Options to display in the dropdown
                                                                                    //selectedValues={selectedOptionCity} // Preselected value to persist in dropdown
                                                                                    onSelect={this.onSelectOptionCity} // Function will trigger on select event
                                                                                    onRemove={this.onRemoveOptionCity} // Function will trigger on remove event
                                                                                    ref={this.multiselectCityRef}
                                                                                    displayValue="label" // Property name to display in the dropdown options
                                                                                    placeholder="شهر ها "
                                                                                    closeIcon="circle2"
                                                                                    emptyRecordMsg="فیلد  در دسترس نیست "
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="همراه"
                                                                              value={mobileFilter}
                                                                              handleInputt={this.handleChangeFilterMobile}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div>
                                                                              <label className="on">وضعیت فعالیت کارشناس خسارت</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"وضعیت فعالیت کارشناس خسارت"}
                                                                                    value={selectedFilterDeactive}
                                                                                    onChange={this.handleFilterDeactive}
                                                                                    options={[
                                                                                          { value: "10", label: "هر دو وضعیت" },
                                                                                          { value: "0", label: "فعال" },
                                                                                          { value: "1", label: "غیر فعال" },
                                                                                    ]}
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <div>
                                                                              <label className="on">وضعیت آنلاین کارشناس خسارت</label>
                                                                              <Select
                                                                                    isSearchable={true}
                                                                                    className="adapter-txtsize"
                                                                                    placeholder={"وضعیت آنلاین کارشناس خسارت"}
                                                                                    value={selectedFilterStatus}
                                                                                    onChange={this.handleFilterStatus}
                                                                                    options={[
                                                                                          { value: "10", label: "هر دو وضعیت" },
                                                                                          { value: "0", label: "آفلاین" },
                                                                                          { value: "1", label: "آنلاین" },
                                                                                    ]}
                                                                              />
                                                                        </div>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Button variant="outlined" color="primary" onClick={this.filterFunc}>
                                                                              {"جستجو "}
                                                                        </Button>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <Button variant="outlined" color="primary" onClick={this.ClearFilter}>
                                                                              {"پاک کردن فیلتر ها "}
                                                                        </Button>
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={this.handleHidePaperChart}
                                                                        >
                                                                              {"مخفی کردن"}
                                                                        </Button>
                                                                  </Grid>
                                                            </Grid>
                                                      </Collapse>
                                                      {showMap ? (
                                                            <Button variant="outlined" color="primary" onClick={this.handleHideMap}>
                                                                  {"بستن نقشه"}
                                                            </Button>
                                                      ) : (
                                                            <Button variant="outlined" color="primary" onClick={this.handleShowMap}>
                                                                  {"نمایش نقشه "}
                                                            </Button>
                                                      )}
                                                      <Collapse in={showMap}>{showMap ?  null: null}</Collapse>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell>
                                                                                    <ExcelFile
                                                                                          element={
                                                                                                <Button variant="outlined" color="primary">
                                                                                                      {" "}
                                                                                                      {"اکسل "}
                                                                                                </Button>
                                                                                          }
                                                                                    >
                                                                                          <ExcelSheet data={expertInfofilter} name="نمایندگان">
                                                                                                <ExcelColumn label="آی دی" value="expert_id" />
                                                                                                <ExcelColumn label="جنسیت" value="expert_gender" />
                                                                                                <ExcelColumn label="نام" value="expert_name" />
                                                                                                <ExcelColumn
                                                                                                      label="نام خانوادگی"
                                                                                                      value="expert_family"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره همراه"
                                                                                                      value="expert_mobile"
                                                                                                />
                                                                                                <ExcelColumn label="تلفن دفتر" value="expert_tell" />
                                                                                                <ExcelColumn label="ایمیل" value="expert_email" />
                                                                                                <ExcelColumn
                                                                                                      label="تلفن ضروری"
                                                                                                      value="expert_required_phone"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="استان "
                                                                                                      value="expert_state_name"
                                                                                                />
                                                                                                <ExcelColumn label="شهر " value="expert_city_name" />
                                                                                                <ExcelColumn
                                                                                                      label="نام محله"
                                                                                                      value="expert_sector_name"
                                                                                                />
                                                                                                <ExcelColumn label="آدرس" value="expert_address" />
                                                                                                <ExcelColumn
                                                                                                      label="نام بانک"
                                                                                                      value="expert_bankname"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره حساب"
                                                                                                      value="expert_banknum"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شماره شبا"
                                                                                                      value="expert_banksheba"
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="شرکت ارزیاب خسارت"
                                                                                                      value="expert_evaluatorco_name"
                                                                                                />
                                                                                                <ExcelColumn label="کد نمایندگی" value="expert_code" />
                                                                                                <ExcelColumn
                                                                                                      label="وضعیت فعالیت "
                                                                                                      value={(col) =>
                                                                                                            col.expert_deactive === "1"
                                                                                                                  ? "غیر فعال"
                                                                                                                  : "فعال"
                                                                                                      }
                                                                                                />
                                                                                                <ExcelColumn
                                                                                                      label="وضعیت آنلاین"
                                                                                                      value={(col) =>
                                                                                                            col.expert_status === "1"
                                                                                                                  ? "آنلاین"
                                                                                                                  : "آفلاین"
                                                                                                      }
                                                                                                />
                                                                                          </ExcelSheet>
                                                                                    </ExcelFile>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "expert_id" ? order : false}
                                                                              >
                                                                                    {" شماره کارشناس خسارت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_id"}
                                                                                          direction={orderBy === "expert_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_code"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "expert_code" ? order : false}
                                                                              >
                                                                                    {" کد نمایندگی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_code"}
                                                                                          direction={orderBy === "expert_code" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_code")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"expert_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام و نام خانوادگی "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_name"}
                                                                                          direction={orderBy === "expert_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_evaluatorco_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شرکت ارزیاب خسارت  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_evaluatorco_name"}
                                                                                          direction={orderBy === "expert_evaluatorco_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_evaluatorco_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"expert_state_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" استان  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_state_name"}
                                                                                          direction={orderBy === "expert_state_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_state_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_city_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شهر  "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_city_name"}
                                                                                          direction={orderBy === "expert_city_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_city_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {" شماره همراه "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_mobile"}
                                                                                          direction={orderBy === "expert_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت فعالیت کارشناس خسارت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_deactive"}
                                                                                          direction={orderBy === "expert_deactive" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"expert_status"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت آنلاین "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "expert_status"}
                                                                                          direction={orderBy === "expert_status" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("expert_status")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {expertInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["expert_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <Avatar
                                                                                                            alt="Remy Sharp"
                                                                                                            src={row["expert_image"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"expert_id"} align={"center"}>
                                                                                                      {row["expert_id"]}
                                                                                                </TableCell>
                                                                                                <TableCell key={"expert_code"} align={"center"}>
                                                                                                      {row["expert_code"]}
                                                                                                </TableCell>
                                                                                                <TableCell key={"expert_name"} align={"center"}>
                                                                                                      {row["expert_name"] + " " + row["expert_family"]}
                                                                                                </TableCell>

                                                                                                <TableCell
                                                                                                      key={"expert_evaluatorco_name"}
                                                                                                      align={"center"}
                                                                                                >
                                                                                                      {row["expert_evaluatorco_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"expert_state_name"} align={"center"}>
                                                                                                      {row["expert_state_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"expert_city_name"} align={"center"}>
                                                                                                      {row["expert_city_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"expert_mobile"} align={"center"}>
                                                                                                      {row["expert_mobile"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"expert_deactive"} align={"center"}>
                                                                                                      {row["expert_deactive"] === "1" ||
                                                                                                      row["expert_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>

                                                                                                <TableCell key={"expert_status"} align={"center"}>
                                                                                                      {row["expert_status"] === "1" ||
                                                                                                      row["expert_status"] === 1 ? (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"آنلاین"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"آفلاین "}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[5, 10, 25, 100]}
                                                            component="div"
                                                            count={expertInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeExpert)
